export default function dataUrlToBlob(dataUrl) {
  if (typeof dataUrl !== 'string') {
    return new Blob([], { type: 'image/jpeg' });
  }

  const [header, base64] = dataUrl.split(',');
  const mime = header.match(/data:(.*?);base64/)?.[1] || 'image/jpeg';
  const binary = atob(base64 || '');
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));

  return new Blob([bytes], { type: mime });
}
